import { Address } from '../api/api';

export function formatAddress(address?: Address | null) {
	return address
		? [address.city, address.street, address.house]
				.filter((str): str is string => Boolean(str))
				.join(', ')
		: '';
}
